import React from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import ServicesDataContext from 'contexts/ServicesDataContext';
import {ServicesData} from 'models/app';

export type WithServicesDataProps = {
    servicesData: ServicesData;
};

export default function withServicesData<T extends WithServicesDataProps>(
    WrappedComponent: React.ComponentType<T>,
) {
    class WithServicesData extends React.Component<Omit<T, keyof WithServicesDataProps>> {
        static displayName = `withServicesData(${
            WrappedComponent.displayName || WrappedComponent.name || 'Component'
        })`;
        static contextType = ServicesDataContext;

        render() {
            return <WrappedComponent {...(this.props as T)} servicesData={this.context} />;
        }
    }

    // Copies non-react specific statics from a child component to a parent component
    hoistNonReactStatics(WithServicesData, WrappedComponent);
    return WithServicesData;
}
